import React, { Fragment } from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';


const CardInformation = styled.span`
  height: 16px;
  line-height: 1.33;
  text-align: center;
  display: block;
  color: #999999;
  margin: ${({ margin }) => margin};
  font-size: ${({ fontSize }) => fontSize};
`;

const splitVisibilityText = (text) => {
  const splittedText = text.split(' ');

  return (
    <Fragment>
      {splittedText[0]}{' '}
      <span style={{ fontWeight: 'bold' }}>{splittedText[1]}</span>
    </Fragment>
  );
};

const VisibilityInformation = ({
  text, ...props
}) => (
  <CardInformation {...props}>
    {splitVisibilityText(text)}
  </CardInformation>

);


VisibilityInformation.propTypes = {
  text: string.isRequired,
  margin: string,
  fontSize: string,
};

VisibilityInformation.defaultProps = {
  margin: '0px',
  fontSize: '12px',
};

export default VisibilityInformation;
